/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AuthClientAudienceRule,
  AuthClientAudienceRule$Outbound,
  AuthClientAudienceRule$outboundSchema,
} from "./authclientaudiencerule.js";

export type SetAuthClientAudienceRequestBody = {
  /**
   * Every rule that should name the client.
   */
  entries: Array<AuthClientAudienceRule>;
  /**
   * The version returned by getAudience.
   */
  expectedVersion: string;
  /**
   * The auth client id.
   */
  id: string;
};

/** @internal */
export type SetAuthClientAudienceRequestBody$Outbound = {
  entries: Array<AuthClientAudienceRule$Outbound>;
  expected_version: string;
  id: string;
};

/** @internal */
export const SetAuthClientAudienceRequestBody$outboundSchema: z.ZodMiniType<
  SetAuthClientAudienceRequestBody$Outbound,
  SetAuthClientAudienceRequestBody
> = z.pipe(
  z.object({
    entries: z.array(AuthClientAudienceRule$outboundSchema),
    expectedVersion: z.string(),
    id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      expectedVersion: "expected_version",
    });
  }),
);

export function setAuthClientAudienceRequestBodyToJSON(
  setAuthClientAudienceRequestBody: SetAuthClientAudienceRequestBody,
): string {
  return JSON.stringify(
    SetAuthClientAudienceRequestBody$outboundSchema.parse(
      setAuthClientAudienceRequestBody,
    ),
  );
}
